import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { SalesMonitoringService } from 'src/app/assabil-sales/services/sales-monitoring-service';
import { SalesMonitoringVisitPipe } from 'src/app/assabil-sales/pipes/sales-monitoring-visit-pipe';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { marker } from 'src/app/tools/models/entities/marker';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { Visit } from 'src/app/assabil-kernel/models/entities/master-data/visit-entity';
import { Chart } from 'node_modules/chart.js';
import { KpiHistory } from 'src/app/assabil-sales/models/dtos/kpi-history';
import { ConfigService } from 'src/app/tools/services/config.service';

  @Component({
    selector: 'sales-monitoring-widget',
    templateUrl: './sales-monitoring-widget.component.html',
    styleUrls: ['./sales-monitoring-widget.component.scss']
  })
  
  export class SalesMonitoringWidgetComponent extends BaseWidget {

    @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
    //roleField = { prop: "roleCode", name: "Role", readOnly: false, modal :  RoleLovComponent};
  
    //filterRole    : Role = new Role();
    date          : Date = new Date();  
    date1         : Date = new Date(); 
    rootRole      : Role; 
    selectedRole  : Role; 
    roleCode      : string
  
    base          : string = "order";

    role                    : Role;
    clickedRoleContainer    : Role[] = [null]; // to have on cell in the Array
    ready         : boolean = false;
    successRate   : number;
    coverageRate  : number;
  
    points        : marker[] = [];
    longitude     : number;
    latitude      : number;
  
    smvPipe               : SalesMonitoringVisitPipe = new SalesMonitoringVisitPipe(this.leanUtilsService);
    
    visitColumns = [
      { prop: 'startTime',                name: 'Heure',     pipe : this.smvPipe    },
   //   { prop: 'endTime',                name: 'Fin',       pipe : this.smvPipe   },
  
      { prop: 'partner.partnerCode',        name: 'Code',                           },
      { prop: 'partner.name',               name: 'Point de vente',                 },
      { prop: 'partner.partnerClusterCode', name: 'Cluster',                        },
      { prop: 'partner.streetName1',        name: 'Adresse',                        },
  
      { prop: 'plannedRank',                name: 'Rang plan',                      },
      { prop: 'actualRank',                 name: 'Rang réel',pipe : this.smvPipe   },
      { prop: 'positionMismatch',           name: 'GPS',      pipe : this.smvPipe   },
      { prop: 'achievedAmount',             name: 'Montant',  pipe : this.smvPipe   },
      { prop: 'achievedVolume',             name: 'Volume',   pipe : this.smvPipe   },
      { prop: 'visitResultName',            name: 'Resultat', pipe : this.smvPipe   },
  
    ]
  
    
    constructor(
      protected salesMonitoringService  : SalesMonitoringService,
      protected leanUtilsService        : LeanUtilsService,
      protected masterDataService       : MasterDataService,
      protected toastr                  : ToastrService,
      protected router                  : Router,
      protected configService     : ConfigService,
      protected location                : Location) {
        super(toastr, leanUtilsService);
  
    }
  
  //----------------------------------------------------------------------
  ngOnInit(){
    super.ngOnInit();
    this.masterDataService.personRoleGet('sales').then(result => {
      this.rootRole = result;
    })
  }
  //----------------------------------------------------------------------

/*
  abxy() {
    // Pie
    let pieChart = new Chart("chart-js-2", {
      type: 'pie',
      data: {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [{
          label: '# of Votes',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)'
          ],
          borderColor: [
            'rgba(255, 99, 132, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });

  }
*/
  //----------------------------------------------------------------------
  selectRoleAndGo(role : Role){ 
    this.selectRole(role);
    this.leanDataForm.hideFilter();
    this.loadData(null);
  }
  selectRole(role : Role){
    if (this.selectedRole != null) this.selectedRole.selected = false;
    this.selectedRole = role;
    this.selectedRole.selected=true;
    this.roleCode = this.selectedRole.roleCode;
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  loadData(roleInMap : Role) {
      if ( (! this.roleCode) ||   (! this.date) ){
        this.toastr.error("Prière de précisier les paramètres de la recherhe");
        return;
      }
      
      let basedOnInvoice =  (this.base=='invoice');
      this.salesMonitoringService.getRoleKpis(this.roleCode, 'sales', this.date, basedOnInvoice, ! basedOnInvoice).then(role => {
        if (this.role) {
          this.merge(role, this.role);
        }
        this.role = role;
        this.ready = true;

        if (roleInMap) {
          this.clickedRoleContainer[0] = roleInMap;
          this.roleClicked();
        }
      })
    }
  //----------------------------------------------------------------------



  merge(role : Role , odlRole : Role){
    role.expanded = odlRole.expanded;
    if (role.subRoles) {
      for (let subRole of role.subRoles){
        let subOldRole : Role = null;
        for (let sor of odlRole.subRoles){
            if (subRole.roleCode == sor.roleCode) {
              subOldRole =  sor;
            }
        }
        if (subOldRole) {
          this.merge(subRole, subOldRole);
        }
      }
    }
  }

  returnBack(){
    this.location.back();
  }

  getRate(v1 : number, v2 : number) : number{
    let rate =  v1 * 100 / v2;
    rate = Math.round(rate * 100 / 100);
    return rate;
  }


  clickedRole : Role;
  showInMap : boolean = false;
  roleClicked(){
    if (this.clickedRoleContainer[0] == null) {
      this.clickedRoleContainer[0] = this.role;
    }
    this.clickedRole  = this.clickedRoleContainer[0]
    if ( this.clickedRole.subRoles){
      this.clickedRole.expanded = ! this.clickedRole.expanded;
      return;
    }
  
    let basedOnInvoice =  (this.base=='invoice');
    this.salesMonitoringService.getRoleVisits(this.clickedRole.roleCode, this.clickedRole.kpisDate, basedOnInvoice, ! basedOnInvoice).then(visits => {
        this.clickedRole.visits = visits;
        this.buildPoints(this.clickedRole);
        this.showInMap          = true;
    })
  }

  
  //startDate   : Date;
  //kpiHistorys : KpiHistory[];
  kpiClicked(roleAndIndex : string){
 
    // if (role.showChart) {
    //   role.showChart = false;
    //   return;
    // }

    // role.showChart = true;

    // this.startDate = new Date(this.date);
    // this.startDate.setDate( this.startDate.getDate() - 30 );

    // let basedOnInvoice =  (this.base == 'invoice');
    // this.salesMonitoringService.kpiHistorysGet(role.roleCode, this.startDate, this.date, basedOnInvoice, ! basedOnInvoice).then(kpiHistorys => {
    //   this.showCharts(role, kpiHistorys) ;
    // })

    this.roleClicked();
    console.log("     ====================================================================== " );
    console.log("     ========== " + roleAndIndex + "     ========== " );
    console.log("     ====================================================================== " );
   }

/*   chartDataReady : boolean = true;
  showCharts(role : Role, kpiHistorys: KpiHistory[]) {

    kpiHistorys.forEach(kpiHistory => {
        let labels  : string[] = [];
        let data    : number[] = [];

        kpiHistory.kpiHistoryItems.forEach(kpiHistoryItem => {
            labels.push(this.leanUtilsService.datePipeDD(kpiHistoryItem.date));
            data.push(kpiHistoryItem.value);
        });

        let chartId = role.roleCode + '§' + kpiHistory.kpiCode;
        let lineChart = new Chart(chartId, {
            type: 'line',
            data: {
            labels: labels,
            datasets: [{
            label: '',
            data: data,
            backgroundColor: [
            'rgba(255, 159, 64, 0.2)'
            ],
            borderWidth: 1
            }]
          },
            options: {
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
        })
    });

  } */
  
  processSelectedVisit(visit : Visit){
    for (let point of this.points){
      let pointPartner  : Partner = point.object;
      if (pointPartner.partnerCode == visit.partner.partnerCode){
        if (point.animation == 'BOUNCE') {
            point.animation = '';
        } else {
          point.animation = 'BOUNCE';
        }

      } else {
        point.animation = '';
      }
    }
    this.points = [...this.points];
  }


  onSelectPoint(index : number) {
    let point   : marker = this.points[index];
    point.animation = '';
  }
  onMapClick(e :  any){

  }
    
    /*
        onSelectPoint(index : number) {
          let point   : marker = this.points[index];
          let ticket  : Ticket = point.object;
    */

  // MAP functions
  //--------------------------------------------------------------------------------------
  buildPoints(role : Role){

    let partners  : Partner[] = [];
    for (let visit  of role.visits){

      let currtentVisitPartner : Partner = visit.partner;
      let partner : Partner = partners.find(tmp => (tmp.partnerCode == currtentVisitPartner.partnerCode) );
      if (partner == null) {
         partners.push(currtentVisitPartner);
         partner = currtentVisitPartner;
         partner.visits = [];
      }
      partner.visits.push(visit);
    }

    this.points = [];
    for (let partner  of partners){

      if ((partner.latitude == null) || (partner.longitude == null))  continue;
      if ((partner.latitude == 0) && (partner.longitude == 0))        continue;
      

      let index = ""
      if (partner.visits[0].actualRank) {
        index = '' + partner.visits[0].actualRank;
      }
      let colors = this.getColors(partner);
      let Iconcolor = this.getIconColor(partner);

      let icon = 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=' + index+ colors;
  
      let point : marker = {     
          lat       : partner.latitude,
          lng       : partner.longitude,
          label     :  this.buildLabel(partner),
          object    : partner,
          draggable : false,
          //iconUrl   : icon,
          iconUrl   : 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_' + Iconcolor + index + '.png',
      };
      this.points.push(point);
      if ((! this.latitude) &&  ((point.lat != 0) || (point.lng != 0))) {
          this.latitude = point.lat;
          this.longitude = point.lng;
      }
    }
  }


  getColors(partner : Partner) : string {
    let colors = '|FF0000|000000';            // Red
    for (let visit  of partner.visits){
      if (visit.visitCode) {
        colors = '|FFFF00|000000';           // Yellow
        if (visit.visitResultCode == "0") {
          colors = '|2EBD07|FFFFFF';         // Green
          break;
        } 
      }
    }
    return colors;
  }  
  
  getIconColor(partner : Partner) : string {
    let colors = 'red';            // Red
    for (let visit  of partner.visits){
      if (visit.visitCode) {
        colors = 'yellow';           // Yellow
        if (visit.visitResultCode == "0") {
          colors = 'green';         // Green
          break;
        } 
      }
    }
    return colors;
  }
      /*
   
      if (visit.visitCode){
        if (visit.visitResultCode == "0"){
            colors = '|2EBD07|FFFFFF';
          } else {
            colors = '|FFFF00|000000';
          }
      }
    */
 

  buildLabel(partner: Partner) : string{

    let res =  "";
    res += "<div class='partner-card-name'>" + partner.name + "</div>";
    res += "<div class='partner-card-cluster'>" + "Cluster :"  + partner.partnerClusterCode + "</div>";
    res += "<div class='partner-card-address'>" + partner.streetName1 + "</div>";
    for (let visit of partner.visits) {
      if (! visit.visitCode) continue;
      res += "<hr>"
      res += "<div >" + visit.visitCode + "</div>";
      if (visit.startTime) {
        let startTime = this.leanUtilsService.timePipe(visit.startTime);
        let endTime = this.leanUtilsService.timePipe(visit.endTime);
        res += "<div> "
        res += "<span class='partner-card-time'>" + startTime + " > " + endTime + "</span>"
        if ( (visit.partner.latitude) && ( visit.partner.longitude)) {
          let iconUrl : string = "assets/images/icons/";
          if (visit.positionMismatch) {
            iconUrl += "rejected.png"; 
          } else {
            iconUrl += "checked.png"; 
          }
          res += " <img class='partner-card-gps' src='" + iconUrl + "' > "
        }
        res += "</div> "
      }
      res += "<hr>"
      if ((visit.visitCode) && (visit.visitResultCode != "0")) {
        res += "<div class='partner-card-nsr'>" + visit.visitResultName + "</div>";
      }
      if (visit.visitResultCode == "0"){
        res += "<div class='partner-card-amount'>" + visit.achievedAmount +" " + this.configService.config.currency + "  </div>";
    //    res += "<div class='partner-card-volume'>" + visit.achievedVolume + " SU </div>";
      }
    }

    return res;
  }

//--------------------------------------------------------------------------------------




  //--------------------------------------------------------------------------------------
  setEntity(data: BaseEntity) {
    throw new Error("Method not implemented.");
  }
  getEntity(): BaseEntity {
    throw new Error("Method not implemented.");
  }
  saveRow(): Promise<BaseEntity> {
    throw new Error("Method not implemented.");
  }
  //--------------------------------------------------------------------------------------
    
  }
  
  